export const SessionStatus = {
    ACTIVE: 'active',
    HOLD: 'hold',
    FINISHED: 'finished',
    GPT: 'gpt',
    BOT: 'bot',
    GEMINI: 'gemini',
    EXPIRED: 'expired',
} as const;